module.exports = __webpack_public_path__ + "static/media/ff_saml.119fe76f.png";